<div [ngClass]="{'error': isError}">
  <p class="title">{{title}}</p>
  <p class="content">{{content}}</p>
  <ul class="btn-list">
    @if (cancelText == null) {
      <li><button class="common-btn-detail" (click)="submit()">{{submitText}}</button></li>
    }
    @if (cancelText != null) {
      <li><button class="common-btn-submit" [ngClass]="{'important': isImportant}" (click)="submit()">{{submitText}}</button></li>
    }
    @if (cancelText != null) {
      <li><button class="common-btn-cancel" (click)="cancel()">{{cancelText}}</button></li>
    }
  </ul>
</div>
